import { render, staticRenderFns } from "./PermissionsGroup.vue?vue&type=template&id=0e19563a&scoped=true"
import script from "./PermissionsGroup.vue?vue&type=script&lang=js"
export * from "./PermissionsGroup.vue?vue&type=script&lang=js"
import style0 from "./PermissionsGroup.vue?vue&type=style&index=0&id=0e19563a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e19563a",
  null
  
)

export default component.exports